export const ScoreList = "ALL_SCORE";
export const ScoreSearch = "Search_Score";